import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme, 'theme')

	const ex5 = await getThemePic(data?.customTheme, 'ex-5')
	const ex6 = await getThemePic(data?.customTheme, 'ex-6')
	const ex7 = await getThemePic(data?.customTheme, 'ex-7')


	return {
		"id": id,
		"elements": [{
			"type": "image",
			"id": "5PanCTPwNs",
			"src": ex5,
			"width": 389.58,
			"height": 332.84,
			"left": 0,
			"top": 228.13,
			"fixedRatio": true,
			"rotate": 0,
			"flipH": false,
			"flipV": false
		},
		{
			"type": "image",
			"id": "nzvMIDt2OD",
			"src": ex6,
			"width": 1000,
			"height": 437.5,
			"left": 409.74,
			"top": -199.88,
			"fixedRatio": true,
			"rotate": 203,
			"flipH": true,
			"flipV": false
		},
		{
			"type": "image",
			"id": "j7G1Zq1uyK",
			"src": "data:image/png;base64,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",
			"width": 163.51,
			"height": 48.26,
			"left": 856.99,
			"top": 236.12,
			"fixedRatio": true,
			"rotate": 0,
			"flipH": false,
			"flipV": false
		},
		{
			"type": "image",
			"id": "ds3M4ugSH2",
			"src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOwAAAB2CAYAAADLLn8xAAALJUlEQVR4nO3dfZBVdR3H8ffl7AosD55FUQRTw9TCh9SsjppjTqWoGVqEWQ6NBuWoPaiYjjiajSlpNGXOZGFFUtmDgjmE6JSVpV5rdBwcUYPUSlDQ2OMDsMvu2dsf33Pby+Xe3bsP5+mez2tmZ/X8WPjB3c+ee36/7+/3AxERERERERERERERERERGUmFUqmUdB9qCvxi0l3oz97AUcA4YAfgAD6wDWgBJgDjw7YCUAJeA3qB0cDuQGvYLs2jFdgOvOi43rNR/AEtUfymTewUYBFwUPj/QfixAWgHplX82jewoHYCLwOHYi8oQDewNfzvQrRdlhi1YT+0lwCXR/EHKLCNWwxcCvwFuBh4EujC7qxvAx4D3gJuBh7CQtoKrAeuAI4EHgZuB54Kf+1usf4NJGoO9j3x36j+AAW2MTdiYT0PWFqj/VHg78BMYEtV20nA14CFwA2R9XCEOa43rK9P+SNNZimwAzsauBKYT+2wLgf2B94B9FS1jQMeBH5BhsIq6TUq6Q5kwGLgGeytbLWDgbOAc9g1rABXYc+4n4msd5IrCmz/2oDjgB/VaT8DGxVcXqd9FrAygn5JTimw/dsHu3O+UKd937Ct3vTMWGBtBP2SnFJg+9eF/RvVG83tBsb08/WlAdpFBkWB7d/L2N3z6DrtTwPTgT3qtL8KvD+CfklOKbD9C7AR3i/Xab8n/HxFnfZbsWfg6SPcL8kpBXZgC7G3xL+p0fY6NuVzOfDeGu0/x55xH4qsd5IrCuzAtgCnA7OBFcCkqvZvAt8F/gycWePrp2Plar/H5mtFhkyFE41ZBZwM3AtsBu4GnqOvJvg5bER4BVbx9FeslrgXeAkL8zzgxfDXPIdNB0G6fmiWsPI6Ar/oY2WXAFOwxQwAzwOrHNfbGH/3RKt1BqcNWIAVSkzGAgsW2lex0O6NhbCEBRastnQ74GIrdQjb0viP34v1f5+Ka09ijwXtWPXWOOAu4ALH9fxdfgdS+/rFZrilnfUosEPn0Ld0rsDOlU4Fdr1zBnW+Nm3KP2TeCZyP/YC63XG9+QCBX5yMPR4swqasjnRc75nq3yQDr1+kFFiJVfkbLvCLM4H7gGsd1/t6uT3wi63AE8AhQLvjelsrvz7vr19UgU3T85OkkON6q4HPA9cFfnFGxfVux/UOx94lLE2oe7mjwMqAHNdbgi3SX1Sj+TJgduAX2+PtVT4psNKoFVgRSLXl2IDaafF2J58UWGnU00BP+Oz6f+H0zibsWVYipsBKo6Zgo9s7rfsN/OIEYCI2rSURU2ClUTOBDY7rVU8rnIBVf62Ov0v5o0onGVDgFw/DVh19okbz9cCzjuuti7dX+aTASr8Cv9gGPAI87rje8qq2q7H9maOZdJRdKLBSV+AXT8T22F3ruJ5XcX0qttfVp4CLHNd7LKEu5o4Cm5wWYC72DDiGnUsXk9QNtAR+8RisPBFgeeAXv4HVF++Hbd3aCcx2XO/uZLqZTwpsMj6LLW5vA/6BLb+D5E8BKK/WGYVtdL4a65uLbThXwAooLgDucFyvK6F+5pYCG7+bsAXvS4FrgP8k2ps6oqqFleFRYOM1HwvrXGBZwn2RDNI8bHzagR8Ct6GwyhApsPE5J/x8SaK9kExTYONzAvA3bHRVZEgU2PhMwfZ3EhkyBTY+G9CuiTJMCmx8/gC8B5vTFBkSBTY+d2EbnH0v6Y5Idimw8XkT+DRwLlYpJDJoCmy8fgVcB3wfO8bj0GS7I1mjbU6TMQcL7STgn0AH9nZ5JGqJy/sk74YtKNiKbeFSws6zbcUq3HqxOuFN2C4S07BNzrvCPt3puN5vh9qJJn/9BqR9iZtPC3ZCu4etgulm5DYWL4d2GnAsMAEL6FXYapsx2DTTcfQNgi3ETi2YDLwbmAEUgVmO620ebAdy8Pr1K6rAqpY4OT3YGT1RL09zgK8A38JO27uoqv1i4BYs0JXHanrYQNmGwC8e6LjevyPupzRAgW1+AbbYfCN21u1mbGvSsluBddhSug7gBwCO6xWBfQO/+BJ2XOYB8XVZ6tGgU37ciZ1xuxR7S1zpfiyot2E7IFY6Btg/8Isa2U4BBTZfrsKeZ0+q0XZt+PnUyouO672C3ZEvjLZr0ggFNl/WY/XMR9do2wSspfbu/g8C0wO/OC7CvkkDFNj82caub3vL3qJ26WQPNuo8NqpOSWMU2HxpA6YCL9RpPwDbY6raFGxZYEc03ZJGKbD5MhMYj436VvsQsBe1d/CfC/zRcb207OyYW5rWyZefAg9gz6q12p4EHq+8GPjFecB04MzIeycDUmDzYzVWRFHruI2fYW+VdxqMCvziLGwj8cWO6z0VeQ9lQFkLrIPVu/ZiBQFdWBleCza3WAqvJ72/b9LKpYl7Au/DFhwcDByBDSxNxOqYj8G2Wj0cGx3ejJUmvivwixcCZwNLHNdbEPdfQGrLSmBPwTYvm4GNVHYCr2CF7HvSt3N+LyNXj5tlJWx8Yk/6XuM3scKI/cJrk7AFAmA/+G4O2yZgI8UvA3Md19MOjymShcD+GvgksAarxtmEzSdeAnwMq49dFrY74UfeFbDQdgJvhJ/HY3fP3hptbVjhfwlbhPC843oPxN9tGUjaA/sw9lbto8DvKq4fhd11vwNcid0hRJpemgN7ExbWQ9h5bnAq8ATwE7THr+RMKudhA7+4B3akxUJ2nchfhFXrnB93v0SSlsrAYqe7dWMDIZXGAKdjy8VEcietgT0cO9Wtu+r6QdgI5p/i7pBIGqQ1sKOwgvNqu2EjoLXaRJpeWgP7L2yfo2rrsU3Fjoi3OyLpkNbA3oFN4M+puv468CgaHZacSmVgHddbD9yH7UFU7RqsGP0LsXZKJAVSGdjQHGA7tkdu5dvjIvBFrMzu7AT6JZKYtO9LvD92pupewLeBe7Hi9eexu+9MbJvQZVjJYt6L/vOqEH50Y3P0ATAaK8csYD/41wA74upQnjcSLwDXY4USU8JrWwEf2yhbpJbXsEq+8pY3HcBKbCO6yM/pzXNgy0YBx9NXpN6FrUApYAUV5SkfyZ8StqihDTgZ+Fx4/cTwczu21vdLWIA/DqyIskMKrMRquN9wCb9+M4BV2M4ap1W1/Rg4D3ucuj+qDkQV2DQPOokMVXm71lOxI0oqnY+Nhawig7tAKrDSrDYCC4DLsHXAlc7Cvve/GnenhkuBlWZ2O/ZsO6vqei9wT43rqafASjN7HdgAvL1G2yP0zTpkhgIrza7e97iD3WkzRYGVZjYZm6t/ukbbSdjdN1MUWGlml2JztCurro/H5mt/GXuPhinNezqJDMdh2AZ9C7HdISs9gD3f3hJ3p4ZLd1hpRh/Ezg9aBtxQcX0iVixxLHaWUObOCtIddnCOx7ap6Uy6I1HLWKVZ+SSIacAZwIexgv8lWPHEJOAjwLnYAoAPUHWGUFYosIMzD9sgTscups8obIVOK1Y00YEd8NWOPcd2YG+Br8ZW9GRSYd26ZxP7w3sK45i4fQ3jtj1F4EzYqW33A2sdEp649vAjtmVa0pACNk2znb53P6OxxQDl5XWvxNmhN7a01m0rUKDk9NLZtYNSTw/s6GVU62ho6aRnRw9OyxgKvTB24mi2vbaFQksr3Tg4TkF32EHqICd31/6+4RoxcVL1hpcyEjToJJIhCqxIhiiwIhmiwIpkiAIrkiEKrEiGKLAiGaLAimSIAiuSIQqsSIYosCIZosCKZIgCK5IhCqxIhiiwIhmiwIpkiAIrkiEKrEiGKLAiGaLAimSIAiuSIQqsSIYosCIZosCKZIgCK5IhCqxIhiiwIhmiwIpkiAIrkiH/A1EEeKHO7qByAAAAAElFTkSuQmCC",
			"width": 184.38,
			"height": 92.19,
			"left": 229.39,
			"top": 413.02,
			"fixedRatio": true,
			"rotate": 0,
			"flipH": false,
			"flipV": false
		},
		{
			"type": "image",
			"id": "yGm94E1d54",
			"src": ex7,
			"width": 153.52,
			"height": 112.5,
			"left": 41.27,
			"top": 27.08,
			"fixedRatio": true,
			"rotate": 0,
			"flipH": false,
			"flipV": false
		},
		{
			"type": "text",
			"id": "HH4QXLKaB7",
			"width": 533.71,
			"height": 61,
			"left": 241.05419181161986,
			"top": 247.06602768903088,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "rgba(157,155,155,1)",
			"content": `<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"font-family: Times New Roman;\">${title}</span></span></p>`,
			"lineHeight": 1,
			"outline": {
				"color": "#000",
				"width": 0,
				"style": "solid"
			},
			"fill": "",
			"vertical": false
		},
		{
			"type": "text",
			"id": "QuAhxsfJg-",
			"left": 389.58,
			"top": 167.06602768903088,
			"width": 236.65838362323984,
			"height": 80,
			"content": `<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">${serial}</span></p>`,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "rgba(157,155,155,1)",
			"vertical": false
		}

		],
		background
	};

}